var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "aggregate_search_shop_inner",
        "shop_" + _vm.value.config.show_type,
      ],
    },
    [
      _vm.value.config.show_type === 3
        ? [_vm._v(" 搜索 "), _c("i", { staticClass: "el-icon el-icon-search" })]
        : [
            _c("i", { staticClass: "el-icon el-icon-search" }),
            _vm._v(" 搜索 "),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }